import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
	AlertController,
	ModalController,
	PopoverController,
} from '@ionic/angular';
import { Observable } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { scheduleEventForm } from '../schedule-event/forms/create-scheduleEvent';
import { ScheduleEventService } from './service/schedule-event.service';
@Component({
	selector: 'app-schedule-event',
	templateUrl: './schedule-event.page.html',
	styleUrls: ['./schedule-event.page.scss'],
})
export class ScheduleEventPage implements OnInit {
	employees: any = [];
	jobfairId: number = 0;

	employees$: Observable<any> = new Observable();
	isload: any;

	constructor(
		public popoverController: PopoverController,
		public modalController: ModalController,
		private location: Location,
		private scheduleEventService: ScheduleEventService,
		private alertController: AlertController,
	) {
		//
	}

	ngOnInit() {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.jobfairId = locationPath[4];
		// this.getJobfairSchedule(this.jobfairId);

		this.scheduleEventService.loadScheduleEventinit(this.jobfairId).subscribe();
		this.scheduleEventService.loadScheduleEventapi(this.jobfairId).subscribe();
		this.employees$ = this.scheduleEventService.fetchScheduleEventdata(
			this.jobfairId,
		);
	}

	// getJobfairSchedule(jobfairId: number) {
	// 	this.scheduleEventService
	// 		.getScheduleList(jobfairId)
	// 		.subscribe(({ data }: any) => {
	// 			this.employees = data.sort(
	// 				(a: any, b: any) => a.startTime - b.startTime,
	// 			);
	// 		});
	// }
	isCanOpenBox = true;

	async addScheduleEvent() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add networking slot	',
					jobfairId: this.jobfairId,
					form: scheduleEventForm,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();
			await modal.onDidDismiss().then(() => {
				// this.getJobfairSchedule(this.jobfairId);
			});

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		return ref.scheduleEventService.addSchedule(this.jobfairId, {
			title: editForm.title,
			imageUrl: editForm.imageUrl,
			startTime: new Date(editForm.startTime).getTime(),
			endTime: new Date(editForm.endTime).getTime(),
		});
	}

	async editScheduleEvent(schedule: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Edit networking slot',
					form: scheduleEventForm,
					jobfairId: this.jobfairId,
					values: {
						...schedule,
						startTime: new Date(schedule.startTime),
						endTime: new Date(schedule.endTime),
					},
					onSubmitForm: this.onEdit,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			const { data } = await modal.onDidDismiss();

			// if (data?.reload) {
			// 	this.getJobfairSchedule(this.jobfairId);
			// }

			this.isCanOpenBox = true;
		}
	}
	onEdit(ref: any, editForm: any) {
		return ref.scheduleEventService.updateSchedule(
			this.jobfairId,
			editForm.id,
			{
				title: editForm.title,
				imageUrl: editForm.imageUrl,
				startTime: new Date(editForm.startTime).getTime(),
				endTime: new Date(editForm.endTime).getTime(),
			},
		);
	}

	deleteScheduleEvent(scheduleId: any) {
		console.log(scheduleId, 'here');
		this.scheduleEventService
			.deleteSchedule(this.jobfairId, scheduleId)
			.subscribe(() => {
				//   this.getJobfairSchedule(this.jobfairId);
			});
	}
}
